class MegamenuItem extends HTMLElement {
    constructor() {
      super();
      this.initMegaMenu();
    }
  
    initMegaMenu() {
      // Getting the parent under which we need to show the menu
      this.parentMenuHandle = this.dataset['dropdown'];
      this.parentMenu = document.querySelector(`.mega-menu__content[data-submenu="${this?.parentMenuHandle}"]`);
      this.parentMenuMobile = document.querySelector(`.mega-menu__content-mobile[data-submenu="${this?.parentMenuHandle}"]`);
  
      if(this.parentMenuHandle && this.parentMenu) {
        this.parentMenu.closest('li.site-nav__item')?.classList.add('rv_mega-menu');
        this.parentMenu.previousElementSibling.classList.contains('site-nav__dropdown') == true ? this.parentMenu.previousElementSibling.remove(): "";
  
        // Add menu into the the header so it can work on hover with CSS
        // TODO: Add Accessability for the menu on hover or focus.
        this.parentMenu.innerHTML = this.innerHTML;
      }

      if(this.parentMenuHandle && this.parentMenuMobile) {
        // this.parentMenu.closest('li.site-nav__item')?.classList.add('rv_mega-menu');
        this.parentMenuMobile.previousElementSibling.classList.contains('mobile-nav__sublist') == true ? this.parentMenuMobile.previousElementSibling.remove(): "";
  
        // Add menu into the the header so it can work on hover with CSS
        // TODO: Add Accessability for the menu on hover or focus.
        this.parentMenuMobile.innerHTML = this.innerHTML;
      }
    }
  }
  
  customElements.define('megamenu-item', MegamenuItem);